import { firestore } from "@/plugins/firebase"
import {
    doc,
    getDoc,
    setDoc,
    collection,
    query,
    onSnapshot,
} from "firebase/firestore"
import Vue from "vue"

export default {
    state: {
        newTradingTimes: {},
    },
    mutations: {},
    actions: {
        async getNewTradingTimes({ state }) {
            const datapath = "/newtradingtimes"
            const collRef = collection(firestore, datapath)
            const q = query(collRef)

            onSnapshot(q, (querySnapshot) => {
                querySnapshot.forEach((docSnap) => {
                    Vue.set(state.newTradingTimes, docSnap.id, { id: docSnap.id, ...docSnap.data() })
                })
            })
        },
        async fetchNewTradingTimes(_, { vertrag }) {
            const docRef = doc(firestore, "newtradingtimes", vertrag)
            const docSnap = await getDoc(docRef)
            if (docSnap.exists()) {
                return docSnap.data()
            }
            return null
        },
        async saveNewTradingTimes({ commit }, { vertrag, tradingtimes }) {
            const docRef = doc(firestore, "newtradingtimes", vertrag)
            const data = {
                trading: {
                    tradingtimes: tradingtimes
                }
            }
            try {
                await setDoc(docRef, data, { merge: true })
                commit("showSnackbar", { message: "Handelszeiten erfolgreich gespeichert", status: "success" }, { root: true })
            } catch (error) {
                console.error("Error saving trading times:", error)
                commit("showSnackbar", { message: "Fehler beim Speichern der Handelszeiten", status: "error" }, { root: true })
            }
        },
    },
}
